import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';

import { saveAttractionRankings } from '~/services/AttractionsService';

import type { SaveRankingsPayload } from '~/types/attractionTypes';

import { attractionQueryKeys } from './attractionQueryKeys';
import { useCanonicalAttractionRedirect } from './useCanonicalAttractionRedirect';

export function useSaveAttractionRankings() {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();
  const { retargetFromMutationError } = useCanonicalAttractionRedirect();

  return useMutation({
    mutationFn: async (payload: SaveRankingsPayload) => {
      return await saveAttractionRankings(payload);
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: attractionQueryKeys.lists() });
      enqueueSnackbar(`${variables.rankings.length} ranking(s) saved and view refreshed`, {
        variant: 'success',
      });
    },
    onError: (error: Error) => {
      if (retargetFromMutationError(error, undefined, { redirect: false })) return;
      enqueueSnackbar(`Error saving rankings: ${error.message || 'Unknown error'}`, { variant: 'error' });
    },
  });
}
